import { Injectable } from '@angular/core';
import { UserService } from '@rubii/frontend-common';
import { ConfigService } from './config.service';
import * as client from '@rubii/sdk-web-user';
import * as cm from '@rubii/sdk-web-custom-metric';
import * as dashboard from '@rubii/sdk-web-dashboard';
import * as notification from '@rubii/sdk-web-notification';
import * as aiClient from '@rubii/sdk-web-openai';
import * as agentClient from '@rubii/sdk-web-agent';

@Injectable()
export class ClientService {
    private domain = 'user';
    account: client.clients.AccountService;
    shard: client.clients.ShardService;
    tenant: client.clients.TenantService;
    user: client.clients.UserService;
    customMetric: cm.clients.CustomMetricService;
    customDimension: cm.clients.CustomDimensionService;
    widget: dashboard.clients.WidgetService;
    notificationPreference: notification.clients.NotificationPreferenceService;
    ai: aiClient.services.OpenaiService;
    llm: aiClient.services.LlmService;
    agent: agentClient.AgentService;

    constructor(private config: ConfigService, private userService: UserService) {
        if (this.config.root.endsWith('/')) {
            this.config.root = this.config.root.substr(0, this.config.root.length - 1);
        }
        this.createClients(this.userService.user?.token);
        // this.account = new client.clients.AccountService(this.config.root, this.userService.user?.token, this.userService.getLoginUrl(), this.domain);
        // this.shard = new client.clients.ShardService(this.config.root, this.userService.user?.token, this.userService.getLoginUrl(), this.domain);
        // this.tenant = new client.clients.TenantService(this.config.root, this.userService.user?.token, this.userService.getLoginUrl(), this.domain);
        // this.user = new client.clients.UserService(this.config.root, this.userService.user?.token, this.userService.getLoginUrl(), this.domain);
        // this.customMetric = new cm.clients.CustomMetricService(this.config.customMetricRoot, this.userService.user?.token, this.userService.getLoginUrl(), 'custom-metric');
        // this.customDimension = new cm.clients.CustomDimensionService(this.config.customMetricRoot, this.userService.user?.token, this.userService.getLoginUrl(), 'custom-metric');
        // this.widget = new dashboard.clients.WidgetService(this.config.dashboardRoot, this.userService.user?.token, this.userService.getLoginUrl(), 'dashboard');
        // this.notificationPreference = new notification.clients.NotificationPreferenceService(this.config.notificationRoot, this.userService.user?.token, this.userService.getLoginUrl(), 'notification');
        // this.ai = new aiClient.services.OpenaiService(this.config.openaiRoot, this.userService.user?.token, this.userService.getLoginUrl(), 'openai');
        // this.llm = new aiClient.services.LlmService(this.config.openaiRoot, this.userService.user?.token, this.userService.getLoginUrl(), 'openai');
    }

    updateToken(token?: string) {
        const t = token ?? this.userService.user?.token;
        this.createClients(t);
    }

    private createClients(token?: string) {
        this.account = new client.clients.AccountService(this.config.root, token, this.userService.getLoginUrl(), this.domain);
        this.shard = new client.clients.ShardService(this.config.root, token, this.userService.getLoginUrl(), this.domain);
        this.tenant = new client.clients.TenantService(this.config.root, token, this.userService.getLoginUrl(), this.domain);
        this.user = new client.clients.UserService(this.config.root, token, this.userService.getLoginUrl(), this.domain);
        this.customMetric = new cm.clients.CustomMetricService(this.config.customMetricRoot, token, this.userService.getLoginUrl(), 'custom-metric');
        this.customDimension = new cm.clients.CustomDimensionService(this.config.customMetricRoot, token, this.userService.getLoginUrl(), 'custom-metric');
        this.widget = new dashboard.clients.WidgetService(this.config.dashboardRoot, token, this.userService.getLoginUrl(), 'dashboard');
        this.notificationPreference = new notification.clients.NotificationPreferenceService(this.config.notificationRoot, token, this.userService.getLoginUrl(), 'notification');
        this.ai = new aiClient.services.OpenaiService(this.config.openaiRoot, token, this.userService.getLoginUrl(), 'openai');
        this.llm = new aiClient.services.LlmService(this.config.openaiRoot, token, this.userService.getLoginUrl(), 'openai');
        this.agent = new agentClient.AgentService(this.config.agentRoot, token, this.userService.getLoginUrl(), 'agent');
    }
}
